module.exports = __webpack_public_path__ + "img/Group 19.57a24cc7.svg";